// Solução definitiva para menu sticky
(function() {
  'use strict';

  function initStickyMenu() {
    // Busca as sections do header dinamicamente (funciona em qualquer ambiente)
    const announcementBar = document.querySelector('[id*="__announcement"]');
    const headerHamburger = document.querySelector('[id*="__header_navigation_hamburger"]');
    const headerPlain = document.querySelector('[id*="__header_navigation_plain"]');
    const headerMobile = document.querySelector('[id*="__header-mobile"]');

    if (!headerPlain && !headerHamburger && !announcementBar && !headerMobile) {
      return;
    }

    // Função para pegar alturas atualizadas com getBoundingClientRect (mais preciso)
    function getHeights() {
      return {
        announcement: announcementBar ? Math.ceil(announcementBar.getBoundingClientRect().height) : 0,
        hamburger: headerHamburger ? Math.ceil(headerHamburger.getBoundingClientRect().height) : 0,
        plain: headerPlain ? Math.ceil(headerPlain.getBoundingClientRect().height) : 0,
        mobile: headerMobile ? Math.ceil(headerMobile.getBoundingClientRect().height) : 0
      };
    }

    // Pega as alturas iniciais
    let heights = getHeights();

    // Cria um placeholder invisível que vai ocupar o espaço dos headers quando ficarem fixed
    const placeholder = document.createElement('div');
    placeholder.id = 'sticky-placeholder';
    placeholder.style.display = 'none';
    placeholder.style.height = '0px';

    // Insere o placeholder antes do headerHamburger
    if (headerHamburger && headerHamburger.parentNode) {
      headerHamburger.parentNode.insertBefore(placeholder, headerHamburger);
    }

    // Marca a posição inicial
    let isSticky = false;

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Recalcula alturas para garantir valores corretos
      heights = getHeights();

      // O sticky ativa SOMENTE quando a announcement bar (barra roxa) sair da tela
      // Nesse momento, o hamburger e o menu devem grudar no topo
      const stickyTriggerPoint = heights.announcement;

      // Ativa sticky quando a barra roxa sair completamente
      if (scrollTop > stickyTriggerPoint && !isSticky) {
        isSticky = true;

        // ATIVA O PLACEHOLDER instantaneamente - sem transições
        // Para mobile, usa apenas altura mobile; para desktop usa hamburger + plain
        const isMobile = window.innerWidth < 1024;
        const totalHeaderHeight = isMobile ? heights.mobile : (heights.hamburger + heights.plain);
        placeholder.style.display = 'block';
        placeholder.style.height = totalHeaderHeight + 'px';

        // Fixa o headerHamburger (logo) no topo instantaneamente
        if (headerHamburger) {
          headerHamburger.style.setProperty('position', 'fixed', 'important');
          headerHamburger.style.setProperty('top', '0', 'important');
          headerHamburger.style.setProperty('left', '0', 'important');
          headerHamburger.style.setProperty('right', '0', 'important');
          headerHamburger.style.setProperty('width', '100%', 'important');
          headerHamburger.style.setProperty('z-index', '9999', 'important');
          headerHamburger.style.setProperty('background-color', '#ffffff', 'important');
          headerHamburger.classList.add('is-sticky');
        }

        // Fixa o headerPlain (menu) logo abaixo do hamburger instantaneamente
        if (headerPlain) {
          headerPlain.style.setProperty('position', 'fixed', 'important');
          headerPlain.style.setProperty('top', heights.hamburger + 'px', 'important');
          headerPlain.style.setProperty('left', '0', 'important');
          headerPlain.style.setProperty('right', '0', 'important');
          headerPlain.style.setProperty('width', '100%', 'important');
          headerPlain.style.setProperty('z-index', '9998', 'important');
          headerPlain.style.setProperty('background-color', '#f8f8f8', 'important');
          headerPlain.classList.add('is-sticky');
        }

        // Fixa o headerMobile (para telas menores) no topo
        if (headerMobile) {
          headerMobile.style.setProperty('position', 'fixed', 'important');
          headerMobile.style.setProperty('top', '0', 'important');
          headerMobile.style.setProperty('left', '0', 'important');
          headerMobile.style.setProperty('right', '0', 'important');
          headerMobile.style.setProperty('width', '100%', 'important');
          headerMobile.style.setProperty('z-index', '9999', 'important');
          headerMobile.style.setProperty('background-color', '#ffffff', 'important');
          headerMobile.classList.add('is-sticky');
        }

      }
      // Remove sticky quando voltar antes do ponto de ativação
      else if (scrollTop <= stickyTriggerPoint && isSticky) {
        isSticky = false;

        // DESATIVA O PLACEHOLDER instantaneamente
        placeholder.style.display = 'none';
        placeholder.style.height = '0px';

        // Remove o fixed do hamburger
        if (headerHamburger) {
          headerHamburger.style.removeProperty('position');
          headerHamburger.style.removeProperty('top');
          headerHamburger.style.removeProperty('left');
          headerHamburger.style.removeProperty('right');
          headerHamburger.style.removeProperty('width');
          headerHamburger.style.removeProperty('z-index');
          headerHamburger.style.removeProperty('background-color');
          headerHamburger.classList.remove('is-sticky');
        }

        // Remove o fixed do plain
        if (headerPlain) {
          headerPlain.style.removeProperty('position');
          headerPlain.style.removeProperty('top');
          headerPlain.style.removeProperty('left');
          headerPlain.style.removeProperty('right');
          headerPlain.style.removeProperty('width');
          headerPlain.style.removeProperty('z-index');
          headerPlain.style.removeProperty('background-color');
          headerPlain.classList.remove('is-sticky');
        }

        // Remove o fixed do mobile
        if (headerMobile) {
          headerMobile.style.removeProperty('position');
          headerMobile.style.removeProperty('top');
          headerMobile.style.removeProperty('left');
          headerMobile.style.removeProperty('right');
          headerMobile.style.removeProperty('width');
          headerMobile.style.removeProperty('z-index');
          headerMobile.style.removeProperty('background-color');
          headerMobile.classList.remove('is-sticky');
        }
      }
    }

    // Adiciona o listener de scroll
    window.addEventListener('scroll', handleScroll);

    // Trigger inicial para caso a página já esteja rolada
    handleScroll();

    // Recalcula alturas após carregamento completo (para produção)
    window.addEventListener('load', function() {
      heights = getHeights();
      handleScroll();
    });
  }

  // Executa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyMenu);
  } else {
    initStickyMenu();
  }
})();
